import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import googleAnalytics from '../services/googleAnalytics';
import MetaPixelService from '../services/metaPixel';

// Component to send SPA route changes to Google Analytics and the Meta Pixel as page views
export const GaPageViewTracker: React.FC = () => {
  const location = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    googleAnalytics.trackPageView(location.pathname + location.search);
    // MetaPixelService.init() already sent the first load's PageView
    if (firstLoad.current) firstLoad.current = false;
    else MetaPixelService.trackPageView();
  }, [location]);

  return null;
};
